import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";

const NotFound = () => (
  <div data-testid="not-found-page" className="max-w-3xl mx-auto px-5 sm:px-8 py-40 text-center">
    <SEO title="Page not found | Risi Wellness Limited" description="The requested Risi Wellness page could not be found." robots="noindex, follow" />
    <p className="text-sm uppercase tracking-[0.2em] text-muted-foreground mb-4">404</p>
    <h1 className="font-serif text-5xl text-primary mb-5">Page not found</h1>
    <p className="text-muted-foreground text-lg mb-8">The page may have moved or the address may be incorrect.</p>
    <Link to="/" className="inline-flex rounded-full bg-primary text-primary-foreground px-7 py-3 font-semibold">Return home</Link>
  </div>
);

export default NotFound;
